import { Typography } from "@circleco/compass/components/Typography";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";

import { t } from "@/i18n-js/instance";

import type { SpaceFormValues } from "../../types";

export const CourseAccessField = () => {
  const { setValue } = useFormContext<SpaceFormValues>();

  useEffect(() => {
    setValue("visibility", "draft");
  }, [setValue]);

  return (
    <Typography variant="body-sm" color="secondary">
      {t("courses.access_description")}
    </Typography>
  );
};
